import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import SectionHeading from "../../common/SectionHeading";
import { selectHasParentRegistration } from "../../../redux/slices/appSettingsSlice";
import { selectAllRegistration } from "../../../redux/slices/registrationSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";

const ConnectedCategoriesHeading = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const hasParentRegistration = useSelector(selectHasParentRegistration);
    const registration = useSelector(selectAllRegistration);
    const { currentRegistration } = registration;
    const isAdditionalParticipant = currentRegistration > 0;
    const isChildParticipant = isAdditionalParticipant || hasParentRegistration;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_DETAILS_STEP,
            state,
        ),
    );
    const {
        options: {
            general: {
                sectionHeading = "How do you want to participate?",
                additionalText = "",
                sectionHeadingforAdditionalParticipants = "How do they want to participate?",
                additionalTextForAdditionalParticipants = "",
            },
        },
    } = control;

    const categoriesHeadingProps = {
        heading: isChildParticipant
            ? sectionHeadingforAdditionalParticipants
            : sectionHeading,
        additionalText: isChildParticipant
            ? additionalTextForAdditionalParticipants
            : additionalText,
    };

    return <SectionHeading {...categoriesHeadingProps} />;
};

ConnectedCategoriesHeading.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedCategoriesHeading;
